import http from "api/httpClient";

export type Option = {
    ou_code: string;
    ou_name: string;
};

export type RNSLevel = {
    id: number;
    name: string;
    visible: boolean;
    selected: string[] | null;
    options: Option[];
    locked?: string[] | null;
};

export type UpdateRNSDropdownsRequest = {
    selection: Record<string, string[]>;
};

export type UpdateRNSDropdownsResponse = {
    levels: RNSLevel[];
};

export async function updateRNSDropdowns(payload: UpdateRNSDropdownsRequest): Promise<UpdateRNSDropdownsResponse> {
    return http.post("/api/v1/rns/update-dropdowns", payload);
}

export type RNSRow = {
    customer_code: string;
    customer_name: string;
    rns_count: number;
    in_transit: number;
    in_stock: number;
    delivered: number;
    rns_lte_15_days: number;
    rns_gt_15_days: number;
};

export type FetchRNSDataRequest = {
    filters: Record<string, string[]>;
    search?: string;
    page: number;
    per_page: number;
    sort_by: string;
    sort_order: 'asc' | 'desc';
};

export type FetchRNSDataResponse = {
    rows: RNSRow[];
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
    has_previous: boolean;
    has_next: boolean;
};

export async function fetchRNSData(payload: FetchRNSDataRequest): Promise<FetchRNSDataResponse> {
    return http.post("/api/v1/rns/fetch-data", payload);
}

export async function downloadRNS(payload: {
    filters: Record<string, string[]>;
    search?: string;
    sort_by?: string;
    sort_order?: 'asc' | 'desc';
}): Promise<Blob> {
    return http.post("/api/v1/rns/download", payload, { responseType: "blob" });
}

export type RNSCustomerRow = {
    cn_number: string;
    cn_date: string | null;
    consignor: string | null;
    consignee: string | null;
    origin: string | null;
    destination: string | null;
    status: string | null;
    rns_days: number;
};

export type FetchRNSCustomerDataRequest = {
    customer_code: string;
    filters: Record<string, string[]>;
    search?: string;
    page: number;
    per_page: number;
    sort_by: string;
    sort_order: 'asc' | 'desc';
};

export type FetchRNSCustomerDataResponse = {
    rows: RNSCustomerRow[];
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
    has_previous: boolean;
    has_next: boolean;
};

export async function fetchRNSCustomerData(
    payload: FetchRNSCustomerDataRequest
): Promise<FetchRNSCustomerDataResponse> {
    return http.post("/api/v1/rns/fetch-customer-data", payload);
}

